export {
  login,
  signup,
  codeLogin,
  getUser,
  gotUser,
  updateUser,
  googleLogin,
  clearNotification,
  removeNotification,
  addNotification,
  updateUserResource,
  logout,
  toggleJustLoggedIn,
  forgotPassword,
  resetPassword,
  confirmEmail,
  updateUserSettings,
} from './user';
export {
  fail,
  start,
  clearLoadingInfo,
  success,
  clearError,
  accessSuccess,
  forgotPasswordSuccess,
  resetPasswordSuccess,
  confirmEmailSuccess,
  confirmEmailStart,
  confirmEmailFail,
} from './loading';
export {
  getRooms,
  getRoom,
  gotRooms,
  createRoom,
  clearCurrentRoom,
  createdRoomConfirmed,
  populateRoom,
  updateRoom,
  addUserRooms,
  removeUserRooms,
  updatedRoom,
  updatedRoomTab,
  updateRoomTab,
  removeRoom,
  updateRoomMembers,
  addRoomMember,
  removeRoomMember,
  roomsRemoved,
  removedRoom,
  createRoomFromActivity,
  setRoomStartingPoint,
  addToLog,
  inviteToRoom,
  addCourseRooms,
  removeCourseRoom,
  createGrouping,
  restoreArchivedRoom,
  archiveRooms,
} from './rooms';
export {
  getCourses,
  getCourse,
  gotCourses,
  updateCourse,
  updatedCourse,
  createdCourse,
  createCourse,
  clearCurrentCourse,
  updateCourseMembers,
  addCourseMember,
  removeCourseMember,
  inviteToCourse,
  addUserCourses,
  removeUserCourse,
} from './courses';
export {
  getActivities,
  gotActivities,
  getCurrentActivity,
  clearCurrentActivity,
  createActivity,
  addUserActivities,
  removeUserActivities,
  createdActivityConfirmed,
  removeActivity,
  activitiesRemoved,
  updateActivity,
  updatedActivity,
  copyActivity,
  setActivityStartingPoint,
  updateActivityTab,
  updatedActivityTab,
  addUserToActivity,
  removeUserFromActivity,
  inviteToActivity,
  removeFromActivity,
} from './activities';
export { joinWithCode, requestAccess, grantAccess } from './access';



// WEBPACK FOOTER //
// ./src/store/actions/index.js